import styled from 'styled-components';

export const Button = styled.div`
  cursor: pointer;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  margin: 0;
  outline: 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  ${(props) => props.theme.Button};
`;
